import React from "react";
import { FormContainerProps } from "./FormContainer.types";
import { FormContainerBox, visuallyHiddenStyles} from "./FormContainer.style";
import {
  ComponentMapping,
  Container,
} from "@adobe/aem-react-editable-components";
import { CoreContainerState } from "@adobe/aem-core-components-react-spa";

export default class FormContainer extends Container<
  FormContainerProps,
  CoreContainerState
> {
  constructor(props: FormContainerProps) {
    super(props);

    this.state = {
      componentMapping: this.props.componentMapping || ComponentMapping,
    };
  }

  render() {
    const { id, backgroundColor, altText } = this.props;

    return (
      <>
        <span style={visuallyHiddenStyles} tabIndex={0}>
          {altText}
        </span>
        <FormContainerBox id={id} $backgroundColor={backgroundColor} $themeChange={this.props.themeChange}>
          {this.childComponents &&
            this.childComponents.map((item, k) => {
              if (k < 2) {
                return (
                  <div className="style-container" key={k}>
                    {item}
                  </div>
                );
              }
              return null;
            })}
        </FormContainerBox>
        {this.childComponents.length < 2 && this.placeholderComponent}
      </>
    );
  }
}
